import type { COMMUNITY_ID } from '~/entities/container/community/interfaces/community'
import type { IRendezvousTopic } from '~/entities/content/ritual/interfaces/topics'
import type { IWiki, WikiVisibility } from '~/entities/content/wiki/interfaces/wiki'
import type { IUser, UserHashKey } from '~/entities/user/user/interfaces/user'

import type { IContentModel } from '~/features-shared/content/interfaces/content-model'
import type { TagActions } from '~/features-shared/content-derived-type/utils/derived-types'

export enum ORDERBY {
  DESC = 'desc',
}

export enum ORDERFIELD {
  UPDATE = 'ds6w_58_lastcontributed',
  CREATION = 'ds6w_58_created',
}

export interface IParams {
  community_id?: COMMUNITY_ID
  content_type?: string
  derivedTypeId?: string
}

export interface IPagineableParams extends IParams {
  page: number
  limit: number
}
export interface ControllerFetchOptions {
  page: number
  limit: number
  sort?: ORDERFIELD
  community_id?: string
  filter?: string
  query?: string
  refine?: string[]
  refineQuery?: string
  withDraft?: boolean
  defaultQuery?: string []
  defaultParams?: Record<string, unknown>
  defaultRefine?: string []
  forceExalead?: boolean
  withSubTypes?: boolean // For derived types
  derivedTypeId?: string // For derived types
  onlyFavoriteCommunities?: boolean // For what's new favorites
}

export interface IExaleadParams extends IParams {
  as_admin?: boolean
  community_id?: string
  contentType?: IContentModel
  legacyFormat?: boolean
  nresults?: number
  order_by?: ORDERBY
  order_field?: ORDERFIELD
  query?: string
  refineUsingQuery?: string
  refine?: string[]
  start?: number
  with_synthesis?: boolean
  withDraft?: boolean
  onlyFavoriteCommunities?: boolean // For what's new favorites
}
export interface IUpdateParams extends IParams {
  contentType: IContentModel
  content_id: string
  description: string
  title: string
  withThumbnailsInfo: boolean
  published?: 0 | 1
  subject6wuri: string

  taggingActions?: TagActions
  tags6w?: any
}

// TODO: to document and to check with backend team the expected types and attributes.
export interface WikiUpdatePageParams {
  minor_edition: 0 | 1
  is_minor_edit: 0 | 1
  revision_description?: string
  content_etag: string

  /**
   * Should lock/unlock the wiki page edition.
   * @info 0: edition enabled.
   * @info 1: edition disabled.
   */
  locked?: IWiki['locked']

  /**
   * Should lock/unlock the wiki page and all its children (deep).
   * @info "locked" attribute will be ignore if this one is provided.
   */
  lockedAll?: boolean
  visibility?: WikiVisibility
  usersToAdd?: UserHashKey[]
  usersToRemove?: UserHashKey[]
}

export interface IConferenceParams {
  title?: string
  description?: string
  start_date?: string
  duration?: number
  scribe?: IUser
  guests?: string[]
  topics?: IRendezvousTopic[]
  subject6wuri?: string
}

// WARNING: a similar enum is defined here '~/entities/content/media/interfaces/media-type'
export enum IMediaType {
  'Picture' = 'Picture',
  'AnimatedPicture' = 'AnimatedPicture',
  'Document' = 'Document',
  'Sound' = 'Sound',
  'Video' = 'Video',
  '3DModel' = '3dModel',
  'Drawing' = 'Drawing',
  'Story' = 'Story',
  'Sketch' = 'Sketch',
  'Whiteboard' = 'Whiteboard',
}
